import React, { useMemo } from 'react';
import { OktonChart as Chart } from '@okton/platform-ui/charts';
import { Movimentacao } from '../../../services/hooks/useDashboard';
import CargaGrafico from './CargaGrafico';
import { useCoresDashboard } from './cores';

interface Props {
  movimentacoes: Movimentacao[];
  isLoading: boolean;
  isError: boolean;
  error?: unknown;
  onRetry: () => void;
  atualizando?: boolean;
}

const TITULO = 'Movimentações';
const ALTURA = '420px';

const MovimentacoesChart: React.FC<Props> = ({
  movimentacoes,
  isLoading,
  isError,
  error,
  onRetry,
  atualizando,
}) => {
  const cores = useCoresDashboard();
  const serie = useMemo(
    () =>
      movimentacoes.map(m => ({
        categoria: m.categoria,
        Valor: Number(m.valor),
        Lançamentos: m.quantidade,
      })),
    [movimentacoes],
  );

  return (
    <CargaGrafico
      atualizando={atualizando}
      titulo={TITULO}
      isLoading={isLoading}
      isError={isError}
      error={error}
      onRetry={onRetry}
      h={ALTURA}
    >
      <Chart
        h={ALTURA}
        title={TITULO}
        data={serie}
        format="bar"
        // Ranking: barras horizontais facilitam comparar as formas de
        // movimentação.
        vertical
        larguraEixo={140}
        // Barras ou pizza. A pizza é o pieTotal (uma fatia por categoria): o
        // pie do Chart monta a pizza de um registro só, que aqui não serve.
        formatosPermitidos={['bar', 'pieTotal']}
        // Uma cor por categoria, igual na barra e na fatia. O primeiro item
        // é a cor da série (convenção do corPorBarra).
        corPorBarra
        graphColor={[cores.categorias[0], ...cores.categorias]}
        dataKeys={['Valor', 'Lançamentos']}
        hiddenKeys={['Lançamentos']}
        nameKey="categoria"
        isMoneyValue={['Valor']}
      />
    </CargaGrafico>
  );
};

export default MovimentacoesChart;
